import styled from "styled-components";
import { Button } from "@renderbus/ui";

export const TextButton = styled(Button)`
  width: min-content;
  padding: 0;
  margin-right: 16px;
  color: var(--main-color) !important;
  border: none;
  display: flex;
  align-items: center;
  &:hover {
    color: #13cb75 !important;
  }
`;

export const SettingButton = styled(Button)`
  background: transparent !important;
  border-color: rgba(113, 117, 125, 1) !important;
  color: rgba(147, 154, 167, 1);
  padding: 2px 6px;
  svg {
    color: rgba(113, 117, 125, 1);
  }
  &:hover {
    border-color: rgba(113, 117, 125, 1) !important;
  }
`;

export const AddButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: 132px;
  height: 40px;
  background: var(--main-color);
  border-radius: 4px;
  border-color: transparent;
  color: #fff;
  &:hover {
    background-color: var(--main-color);
    border-color: transparent;
    color: #fff;
  }
  &:active,
  &:focus {
    background-color: var(--main-color);
    border-color: transparent;
    color: #fff;
  }
`;

export const PlusIcon = styled.i`
  width: 12px;
  height: 12px;
  margin-right: 6px;
  position: relative;
  &:before {
    content: "";
    width: 12px;
    height: 12px;
    position: absolute;
    left: 50%;
    top: 4px;
    transform: translateX(-1px);
    border-left: 2px white solid;
  }
  &:after {
    content: "";
    width: 12px;
    height: 12px;
    top: 50%;
    left: -6px;
    transform: translateY(-1px);
    position: absolute;
    border-top: 2px white solid;
  }
`;

export const GotoEnterpriseWrapper = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 160px;
  button {
    width: 120px;
  }
`;
export const GotoEnterpriseTitle = styled.div`
  color: #ffffffd9;
  font-size: 36px;
`;
export const GotoEnterpriseTip = styled.div`
  font-size: 18px;
  color: #ffffff;
  margin: 38px 0 106px;
`;

export const SearchAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
